require('../../modules/es.reflect.construct');
var path = require('../../internals/path');

module.exports = path.Reflect.construct;



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js-pure/es/reflect/construct.js
// module id = 493
// module chunks = 0 1